"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("../../consts");
const formatDollarAmount_1 = require("../../utils/formatDollarAmount");
const setupNumberField_1 = require("../../utils/setupNumberField");
const consts_2 = require("./consts");
const els_1 = require("./els");
function update() {
    const frequency = els_1.ANNUAL_RADIO_EL.checked
        ? "annual"
        : "monthly";
    const seats = parseInt(els_1.SEATS_INPUT_EL.value);
    if (seats < 1 || typeof seats !== "number")
        return;
    els_1.FREQUENCY_RADIO_LABEL_ELS.forEach((el) => el.classList.remove(consts_2.ACTIVE_RADIO_CLASSNAME));
    switch (frequency) {
        case "annual":
            els_1.ANNUAL_RADIO_LABEL_EL.classList.add(consts_2.ACTIVE_RADIO_CLASSNAME);
            break;
        case "monthly":
            els_1.MONTHLY_RADIO_LABEL_EL.classList.add(consts_2.ACTIVE_RADIO_CLASSNAME);
            break;
    }
    consts_1.EDITIONS.forEach((edition) => {
        const pricesPerSeat = consts_1.EDITION_PRICES_PER_SEAT[edition];
        const { priceEl, subTextEl, unavailableEl } = els_1.EDITION_HEADER_EL_MAP[edition];
        if (pricesPerSeat) {
            const pricePerSeat = pricesPerSeat[frequency];
            switch (typeof pricePerSeat) {
                case "number":
                    unavailableEl.style.display = "none";
                    priceEl.style.display = "block";
                    if (!pricePerSeat) {
                        priceEl.textContent = "Free";
                        subTextEl.style.visibility = "hidden";
                    }
                    else {
                        priceEl.textContent = (0, formatDollarAmount_1.formatDollarAmount)(pricePerSeat * seats, true);
                        subTextEl.style.visibility = "visible";
                    }
                    break;
                default:
                    priceEl.style.display = "none";
                    unavailableEl.style.display = "block";
                    unavailableEl.textContent = `Unavailable on ${frequency}\xa0plans`;
                    subTextEl.style.visibility = "hidden";
                    break;
            }
        }
        else {
            priceEl.textContent = "Let's talk!";
            subTextEl.style.visibility = "hidden";
        }
    });
}
els_1.ANNUAL_RADIO_EL.addEventListener("change", update);
els_1.MONTHLY_RADIO_EL.addEventListener("change", update);
(0, setupNumberField_1.setupNumberField)(els_1.SEATS_INPUT_EL, update, { defaultValue: 1, min: 1 });
update();
